import clsx from 'clsx';
import { Check } from 'lucide-react';
import React from 'react';
import StepperSeparator from '../../../assets/stepper-separater.svg';
import Badge from '../Badge';

export interface StepperProps {
  steps: string[];
  currentStep: number;
  completed?: boolean;
}

const Stepper = ({ steps, currentStep, completed = false }: StepperProps) => {
  const stepStates = steps.map((label, index) => {
    const stepNumber = index + 1;

    return {
      label,
      stepNumber,
      isCompleted: completed || stepNumber < currentStep,
      isActive: !completed && stepNumber === currentStep,
      isReached: stepNumber <= currentStep,
    };
  });

  return (
    <>
      <div className="flex flex-col md:hidden gap-2 text-white">
        <div className="flex items-center justify-center gap-3">
          {stepStates.map(({ isCompleted, isActive }, index) => (
            <span
              key={index}
              data-testid="stepper-bar"
              className={clsx(
                'h-2 w-8 rounded-full',
                isCompleted
                  ? 'bg-success'
                  : isActive
                    ? 'bg-electric'
                    : 'bg-waves'
              )}
            />
          ))}
        </div>
        <span className="text-sm font-semibold">
          {completed
            ? 'All steps completed'
            : `Step ${currentStep} of ${steps.length}: ${steps.at(currentStep - 1)}`}
        </span>
      </div>

      <div className="hidden md:flex items-center justify-center gap-4">
        {stepStates.map(
          ({ label, stepNumber, isCompleted, isActive }, index) => (
            <React.Fragment key={label}>
              {index > 0 && <StepperSeparator />}
              <div className="inline-flex items-center gap-2">
                <Badge
                  shape="circle"
                  variant={
                    isCompleted ? 'success' : isActive ? 'primary' : 'secondary'
                  }
                >
                  {isCompleted ? <Check size={24} /> : stepNumber}
                </Badge>
                <p
                  className={clsx(
                    'text-sm',
                    isActive ? 'font-semibold text-white' : 'text-waves'
                  )}
                >
                  {label}
                </p>
              </div>
            </React.Fragment>
          )
        )}
      </div>
    </>
  );
};

export default Stepper;
